import {useEffect, useState} from "react";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {HOSTNAME} from "../configs/Domain";
import {prepareJsonPayload} from "../store/utils";


const COMPANY_LOGO_PATH = 'https://storage.googleapis.com/finiat-web-static-resources/company-brands/id-lookup';


export const formatCompanyLogoUrl = (cid)=>{
    if (!cid){
      return `${COMPANY_LOGO_PATH}/finiat.png`
    }
    return `${COMPANY_LOGO_PATH}/${cid}.png`
}






export const updateCompanyDetails = createAsyncThunk(
  'company/updateDetails',
  async ({ userId, companyId, data }, { rejectWithValue }) => {
    try {
      const response = prepareJsonPayload({
        data: {
          ...data, companyId
        }, method: "POST"
      })
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update company details');
      }

      const updatedCompany = await response.json();
      return updatedCompany;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCompanyLogo = async (companyId, logoFile) => {
  const formData = new FormData();
  formData.append('logo', logoFile);
  formData.append('company_id', companyId);

  try {
    const response = await fetch(`${HOSTNAME}/company/logo/upload`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to update company logo');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error updating company logo:', error);
    throw error;
  }
};



export const addPortfoliosToCompany = createAsyncThunk(
  'company/addPortfoliosToCompany',
  async ({ userId, portfolioIds, }, { rejectWithValue }) => {
    try {
      const companyId = localStorage.getItem('cid');
      const response = await fetch(`${HOSTNAME}/company/portfolios/add`, prepareJsonPayload({
        data: {
          portfolioIds, companyId

        }, method: "POST"
      }))
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update company details');
      }
      const data = response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const updateCompanyPortfolio = createAsyncThunk(
  'company/updatePortfolio',
  async ({ portfolioId, companyId, updateFields }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${HOSTNAME}/company/portfolios/${portfolioId}/update`,
        prepareJsonPayload({
          data: {
            companyId,
            updateFields
          },
          method: "PATCH"
        })
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update portfolio');
      }

      const data = await response.json();
      return {
        portfolioId,
        ...updateFields
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createPathPage = createAsyncThunk(
  'company/createPathPage',
  async ({ title, portfolioIds, maxSelect = 1 }, { rejectWithValue }) => {
    try {
      const companyId = localStorage.getItem('cid');
      const response = await fetch(
        `${HOSTNAME}/company/path-pages/create`,
        prepareJsonPayload({
          data: {
            companyId,
            title,
            portfolioIds,
            maxSelect
          },
          method: "POST"
        })
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to create path page');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updatePathPage = createAsyncThunk(
  'company/updatePathPage',
  async ({ pageId, updateFields }, { rejectWithValue }) => {
    try {
      const companyId = localStorage.getItem('cid');
      const response = await fetch(
        `${HOSTNAME}/company/path-pages/${pageId}/update`,
        prepareJsonPayload({
          data: {
            companyId,
            updateFields
          },
          method: "PATCH"
        })
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update path page');
      }

      return {
        pageId,
        ...updateFields
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletePathPage = createAsyncThunk(
  'company/deletePathPage',
  async ({ pageId }, { rejectWithValue }) => {
    try {
      const companyId = localStorage.getItem('cid');
      const response = await fetch(
        `${HOSTNAME}/company/path-pages/${pageId}/delete`,
        prepareJsonPayload({
          data: {
            companyId
          },
          method: "DELETE"
        })
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to delete path page');
      }

      return pageId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateCompanyActivePathIds = createAsyncThunk(
  'company/updateActivePathIds',
  async ({ pathIds }, { rejectWithValue }) => {
    try {
      const companyId = localStorage.getItem('cid');
      const response = await fetch(
        `${HOSTNAME}/company/path-pages/set-active`,
        prepareJsonPayload({
          data: {
            companyId,
            pathIds
          },
          method: "POST"
        })
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update active path pages');
      }

      return { pathIds };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const updateCompanyFields = createAsyncThunk(
  'company/updateFields',
  async ({ companyId, updateFields }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${HOSTNAME}/company/update-fields`,
        prepareJsonPayload({
          data: {
            companyId,
            updateFields
          },
          method: 'PATCH'
        })
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update company fields');
      }

      const updatedCompany = await response.json();
      return { companyId, updateFields };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
